import { render, staticRenderFns } from "./Contact.vue?vue&type=template&id=080065e4&scoped=true&"
import script from "./Contact.vue?vue&type=script&lang=js&"
export * from "./Contact.vue?vue&type=script&lang=js&"
import style0 from "./Contact.vue?vue&type=style&index=0&id=080065e4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "080065e4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('080065e4')) {
      api.createRecord('080065e4', component.options)
    } else {
      api.reload('080065e4', component.options)
    }
    module.hot.accept("./Contact.vue?vue&type=template&id=080065e4&scoped=true&", function () {
      api.rerender('080065e4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/js/src/app/components/dashboard/practice-info/Contact.vue"
export default component.exports